<template >
    <div class="custimize-iframe">
        <div class="iframe-cont">
            <iframe :src="`https://ai.tcmcds.com/zhGraph/res/content_bzy.html?keywords=%E4%BA%BA%E5%8F%82`"  frameborder="0"></iframe>
        </div>
    </div>
</template>
<script>
export default {
    // data () {
    //     return {
    //         keywords:'赵炳南',
    //         sequence:this.$route.query.sequence||7,
    //     }
    // },
    // mounted(){
    //     if(this.sequence==6){
    //         this.keywords='帕金森'
    //     }else if(this.sequence==7){
    //         this.keywords='%E4%BA%BA%E5%8F%82'
    //     }else if(this.sequence==9){
    //         this.keywords='赵炳南'
    //     } 
    // }
}
</script>
<style lang="less" scoped>
.custimize-iframe{
    width: 100%;
    min-width: 1200px;
    background: #f5f5f5;
    .iframe-cont{
        width: 1200px;
        height: 840px;
        margin: 0 auto; 
        ::v-deep iframe{
            width: 100%;
            height: 100%;
        }
    }
}
</style>